import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { ConsultaCustomizada } from 'src/app/persistences/consulta-customizada';
import { ConsultaCustomizadaService } from 'src/app/services/consulta-customizada.service';

@Component({
  standalone: false,
  selector: 'app-pesquisa-avancada-customizada',
  templateUrl: './pesquisa-avancada-customizada.component.html',
  styleUrls: ['./pesquisa-avancada-customizada.component.css']
})
export class PesquisaAvancadaCustomizadaComponent implements OnInit, OnChanges {
  @ViewChild(MatAutocompleteTrigger) trigger!: MatAutocompleteTrigger;
  formConsulta: FormGroup;
  public consultaCustomizada = new ConsultaCustomizada;

  @Input()
  labelDaDescricao = 'Descrição';
  @Input()
  identificador: string;
  @Input()
  campoFiltro: string;
  @Input()
  campoChaveDoFiltro: string;  
  @Input()
  complementoConsulta: string;
  @Input()
  itemInicial: string;
  @Input()
  possuiItemInicial: boolean;
  @Input()
  campoRequerido = false; 
  @Input()
  lookupExibicao: string[];
  @Input()
  disabled: boolean;
  @Input()
  listaInicial;
  @Output()
  itemCosulta = new EventEmitter<number>();
  public codigoItem: number;  
  public descricaoItem: string[];
  public indiceAtual:number;
  
  autocompleteOpened = false;
  
  constructor(
    private consultaCustomizadaService: ConsultaCustomizadaService,
    private formBuilder: FormBuilder,
    private snackBarManager: SnackbarManager
  ) {
    this.consultaCustomizada.resultados = this.listaInicial;
  }

  ngOnInit(): void {
    this.formConsulta = this.formBuilder.group({
      codigo: new FormControl(''),
      descricao: new FormControl({ value: '', disabled: this.disabled }),
    })
    if(this.possuiItemInicial){
      this.descricaoItem = [];
      this.pesquisaEspecifica(this.itemInicial);
    }    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] && !changes['disabled'].firstChange) {
      const isDisabled = changes['disabled'].currentValue;
      if (isDisabled) {
        this.formConsulta.controls['descricao'].disable();
      } else {
        this.formConsulta.controls['descricao'].enable();
      }
    }
  }

  onSearch(termoPesquisado: string) {
    let result: string [];
    this.consultaCustomizada.identificador = this.identificador;
    this.consultaCustomizada.campoFiltro = this.campoFiltro;
    this.consultaCustomizada.complementoConsulta = this.complementoConsulta;
    if (termoPesquisado.length > 0) {
      this.consultaCustomizadaService.getConsulta(termoPesquisado, this.consultaCustomizada).subscribe((resultadosDaPesquisa) => {
        result = resultadosDaPesquisa.map((array) => {       
          const cdAcesso = array.find((item) => item.nmCampo === (this.lookupExibicao[0].toLowerCase()))?.valor;
          const nmAcao = array.find((item) => item.nmCampo === this.lookupExibicao[1].toLowerCase())?.valor;
          return {cdAcesso, descricao:  cdAcesso + " " + nmAcao };
        });
        this.consultaCustomizada.resultados = result;
        this.indiceAtual = 0;
      },
      (error)=>{
        this.snackBarManager.openSnackBarErro(error, 'Não foi possível realizar a busca.', "Ok", 3000)
      });
    } else {
      this.consultaCustomizada.resultados = [];
      this.itemCosulta.emit(null);
    }
  }

  pesquisaEspecifica(codigoItemPesquisado: string) { 
    let result = [];   
    if(this.possuiItemInicial){      
      codigoItemPesquisado = this.itemInicial;
      this.consultaCustomizada.identificador = this.identificador;
      this.consultaCustomizada.campoFiltro = this.campoChaveDoFiltro;
      this.consultaCustomizada.complementoConsulta = this.complementoConsulta;  
      if (parseInt(codigoItemPesquisado) > 0 || codigoItemPesquisado.length > 0) {
        this.consultaCustomizadaService.getConsulta(codigoItemPesquisado, this.consultaCustomizada).subscribe((resultadosDaPesquisa) => {          
          result = resultadosDaPesquisa.map((array) => {          
            const cdAcesso = array.find((item) => item.nmCampo === (this.lookupExibicao[0].toLowerCase()))?.valor;
            const nmAcao = array.find((item) => item.nmCampo === this.lookupExibicao[1].toLowerCase())?.valor;
            return {cdAcesso, descricao:  cdAcesso + " " + nmAcao };
          });          
          this.consultaCustomizada.resultados = result;          
          this.selecionarItem(result[0]);
        },
        (error)=>{
          this.snackBarManager.openSnackBarErro(error, 'Não foi possível realizar a busca.', "Ok", 3000)
        });
      } else {
        this.consultaCustomizada.resultados = [];
      }
      this.possuiItemInicial = false;
    } else{
      this.onSearch(codigoItemPesquisado)
    }  
  }

  selecionarItem(item) {
    this.descricaoItem = item.descricao;
    this.itemCosulta.emit(item.cdAcesso);
    this.consultaCustomizada.resultados = [];
  }

  limpar() {
    this.descricaoItem = [];
    this.codigoItem = null;
    this.formConsulta.reset({
      codigo: '',
      descricao: ''
    });
    this.consultaCustomizada.resultados = [];
    this.indiceAtual = null;
  }

  openAutocomplete() {
    this.onSearch('%');
    this.trigger.openPanel();
  }
}